// @ts-nocheck
// src/theme/index.ts
import { extendTheme, ThemeConfig } from "@chakra-ui/react";

// Create Theme
const theme = extendTheme({
  styles: {
    global: {
      "html, body": {
        overflowX: "hidden", // 👈 horizontal scroll hat gaya
        margin: 0,
        padding: 0,
      },
      "#root": {
        overflowX: "hidden",
      },
    },
  },
  mode: "wireframe",
  colors: {
    dark: "#121212",
    info: "#00B8D4",
    input: {
      bg: "#1E1E1E",
      text: "#FFFFFF",
      border: "#2A2A2A",
      placeholder: "#666666",
    },
    white: "#FFFFFF",
    danger: "#FF4444",
    footer: { bg: "#121212", text: "#FFFFFF" },
    header: { bg: "#121212", text: "#FFFFFF" },
    primary: {
      50: "#F4FFE6",
      100: "#AEFF00",
      200: "#9EEF00",
      300: "#8EDF00",
      400: "#7ECF00",
      500: "#AEFF00",
      600: "#5EAF00",
      700: "#4E9F00",
      800: "#3E8F00",
      900: "#2E7F00",
    },
    sidebar: {
      bg: "#1E1E1E",
      text: "#FFFFFF",
      hover: "#2A2A2A",
    },
    success: "#AEFF00",
    warning: "#FFB800",
    selected: "#AEFF00",
    cardColor: "#1E1E1E",
    textColor: "white",
    background: "#121212",
    borderColor: "#2A2A2A",
    blue: {
      50: "#eaf3fa",
      100: "#cce0f3",
      200: "#98c1e7",
      300: "#6fa8dd",
      400: "#468fd3",
      500: "#3182ce",
      600: "#2c75b9",
      700: "#225b90",
      800: "#194167",
      900: "#0a1a29",
    },
    cyan: {
      50: "#e6f8fb",
      100: "#bfeef4",
      200: "#80deea",
      300: "#4dd0e1",
      400: "#1ac3d8",
      500: "#00bcd4",
      600: "#00a9bf",
      700: "#008494",
      800: "#005e6a",
      900: "#00262a",
    },
    red: {
      50: "#fcecec",
      100: "#f9cfcf",
      200: "#f29f9f",
      300: "#ed7878",
      400: "#e85151",
      500: "#e53e3e",
      600: "#ce3838",
      700: "#a02b2b",
      800: "#731f1f",
      900: "#2e0c0c",
    },
    orange: {
      50: "#fdf3eb",
      100: "#fbe2cd",
      200: "#f6c49b",
      300: "#f2ac72",
      400: "#ef954a",
      500: "#ed8936",
      600: "#d57b31",
      700: "#a66026",
      800: "#77451b",
      900: "#2f1b0b",
    },
    green: {
      50: "#ebf6f0",
      100: "#cde8da",
      200: "#9cd0b4",
      300: "#74bd96",
      400: "#4caa78",
      500: "#38a169",
      600: "#32915f",
      700: "#27714a",
      800: "#1c5135",
      900: "#0b2015",
    },
    yellow: {
      50: "#fdfaed",
      100: "#faf2d2",
      200: "#f6e4a5",
      300: "#f2d981",
      400: "#eece5d",
      500: "#ecc94b",
      600: "#d4b544",
      700: "#a58d35",
      800: "#766526",
      900: "#2f280f",
    },
    purple: {
      50: "#f2effb",
      100: "#dfd6f5",
      200: "#c0adea",
      300: "#a68ce2",
      400: "#8d6bd9",
      500: "#805ad5",
      600: "#7351c0",
      700: "#5a3f95",
      800: "#402d6b",
      900: "#1a122b",
    },
    pink: {
      50: "#fbecf4",
      100: "#f5cfe2",
      200: "#ea9fc6",
      300: "#e279af",
      400: "#d95298",
      500: "#d53f8c",
      600: "#c0397e",
      700: "#952c62",
      800: "#6b2046",
      900: "#2b0d1c",
    },
    gray: {
      50: "#f1f2f5",
      100: "#dcdfe5",
      200: "#b8c0cb",
      300: "#9ca6b6",
      400: "#7f8da1",
      500: "#718096",
      600: "#667387",
      700: "#4f5a69",
      800: "#39404b",
      900: "#171a1e",
    },
    black: {
      50: "#e6e6e6",
      100: "#bfbfbf",
      200: "#808080",
      300: "#4d4d4d",
      400: "#1a1a1a",
      500: "#000000",
      600: "#000000",
      700: "#000000",
      800: "#000000",
      900: "#000000",
    },
    whiteAlpha: {
      50: "rgba(255, 255, 255, 0.04)",
      100: "rgba(255, 255, 255, 0.086)",
      150: "rgba(255, 255, 255, 0.133)",
      200: "rgba(255, 255, 255, 0.179)",
      250: "rgba(255, 255, 255, 0.225)",
      300: "rgba(255, 255, 255, 0.272)",
      350: "rgba(255, 255, 255, 0.318)",
      400: "rgba(255, 255, 255, 0.364)",
      450: "rgba(255, 255, 255, 0.411)",
      500: "rgba(255, 255, 255, 0.457)",
      550: "rgba(255, 255, 255, 0.503)",
      600: "rgba(255, 255, 255, 0.549)",
      650: "rgba(255, 255, 255, 0.596)",
      700: "rgba(255, 255, 255, 0.642)",
      750: "rgba(255, 255, 255, 0.688)",
      800: "rgba(255, 255, 255, 0.735)",
      850: "rgba(255, 255, 255, 0.781)",
      900: "rgba(255, 255, 255, 0.827)",
      950: "rgba(255, 255, 255, 0.874)",
      1000: "rgba(255, 255, 255, 0.92)",
    },
    blackAlpha: {
      50: "rgba(0, 0, 0, 0.04)",
      100: "rgba(0, 0, 0, 0.086)",
      150: "rgba(0, 0, 0, 0.133)",
      200: "rgba(0, 0, 0, 0.179)",
      250: "rgba(0, 0, 0, 0.225)",
      300: "rgba(0, 0, 0, 0.272)",
      350: "rgba(0, 0, 0, 0.318)",
      400: "rgba(0, 0, 0, 0.364)",
      450: "rgba(0, 0, 0, 0.411)",
      500: "rgba(0, 0, 0, 0.457)",
      550: "rgba(0, 0, 0, 0.503)",
      600: "rgba(0, 0, 0, 0.549)",
      650: "rgba(0, 0, 0, 0.596)",
      700: "rgba(0, 0, 0, 0.642)",
      750: "rgba(0, 0, 0, 0.688)",
      800: "rgba(0, 0, 0, 0.735)",
      850: "rgba(0, 0, 0, 0.781)",
      900: "rgba(0, 0, 0, 0.827)",
      950: "rgba(0, 0, 0, 0.874)",
      1000: "rgba(0, 0, 0, 0.92)",
    },
  },
  fonts: {
    heading: "'GT America', sans-serif",
    body: "'Inter', sans-serif",
    mono: "Menlo, Monaco, Consolas, 'Courier New', monospace",
  },
  borderWidths: { xs: "1px", sm: "2px", md: "2px" },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "4rem",
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  radii: {
    none: "0",
    sm: "0.25em",
    md: "0.5em",
    lg: "0.75em",
    xl: "1em",
    "2xl": "1.5em",
    "3xl": "2em",
    full: "9999px",
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
  },
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },
});

export const kStyleGlobal = theme;
export default theme;
